import React from "react";

interface LinkProps {
  href: string,
  children: string
}

const Link: React.FC<any> = (props: LinkProps) => {
  const {children} = props;
  return <a {...props} target={'_blank'}>{children}</a>
}

export default Link;